if (!customElements.get('hero-widget')) {
  class HeroWidget extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 1,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        loop: true,
        watchOverflow: true,
        breakpoints: {},
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  customElements.define('hero-widget', HeroWidget);
}
